import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/lj/workspace/bold/site/src/components/mdx/MDXPageLayout";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "grid",
      "style": {
        "position": "relative"
      }
    }}>{`Grid`}</h1>
    <p>{`Grid systems are used to guide the page construction through a series of rows and columns that arrange your content. Consistent use of a grid system provides the foundation for a harmonic page with well-positioning elements on the screen. The design system uses a 12 columns system, varying the gutter and the size of the columns according to the page resolution.`}</p>
    <p><img parentName="p" {...{
        "src": "/image/grid-columns.png",
        "alt": "Grid columns"
      }}></img></p>
    <h2 {...{
      "id": "side-menu",
      "style": {
        "position": "relative"
      }
    }}>{`Side menu`}</h2>
    <p>{`When the page has a fixed side menu, it will be positioned outside the boundaries of the grid, including the margins. The main content is moved aside to provide space for the side menu, and the grid and content area are condensed.`}</p>
    <h2 {...{
      "id": "breakpoints",
      "style": {
        "position": "relative"
      }
    }}>{`Breakpoints`}</h2>
    <p>{`The number of columns is independent of the size of the window and is always 12.`}</p>
    <table>
  <thead>
    <tr>
      <th>Resolution</th>
      <th>Columns</th>
      <th>Gutter</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1024 px</td>
      <td>12</td>
      <td>16 px</td>
    </tr>
    <tr>
      <td>1280 px</td>
      <td>12</td>
      <td>32 px</td>
    </tr>
  </tbody>
    </table>
    <h2 {...{
      "id": "best-practices",
      "style": {
        "position": "relative"
      }
    }}>{`Best practices:`}</h2>
    <ul>
      <li parentName="ul">{`Use multiples of 8px when setting sizes, spacing, and element positions.`}</li>
      <li parentName="ul">{`Whenever possible, align the elements, vertically and horizontally.`}</li>
      <li parentName="ul">{`Use good spacing between the page content blocks. This creates a visual grouping between similar items and makes navigation easier.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      